﻿export class HompageScroll {

    public static scrollTosection($: JQueryStatic): void {

        const homeHero = $('.homepage__hero').height();

        $('.homepage__scroll-to-btn').on('click', function () {

            $('html, body').animate({
                scrollTop: homeHero
            }, 1500);

        });

    }
}